import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'ASSET_UPDATE',
    smsDelete : 'ASSET_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        assetType: [],
        typeDetail: {},
        assetCode: null,
        asset: [],
        assetQR: [],
        assetUnmarked: [],
        assetDetail: {},

        submitSuccess: false,
        assetLoading: false,
        assetError: false,
        assetQRLoading: false,
        assetQRError: false,
        assetUnmarkedLoading: false,
        assetUnmarkedError: false,
        assetTypeLoading: false,
        assetTypeError: false,
        assignLoading: false,
        assignError: false,
        attachmentLoading: false,
        attachmentError: false,

        ...store
    },

    mutations : {
        ...mutations,

        SET_ASSET(state, asset) {
            state.asset = asset;
        },

        SET_QR_ASSET(state, asset) {
            state.assetQR = asset;
        },

        SET_UNMARKED_ASSET(state, asset) {
            state.assetUnmarked = asset;
        },

        SET_ASSET_DETAIL(state, asset) {
            state.assetDetail = asset;
        },

        SET_ASSET_CODE(state, code) {
            state.assetCode = code;
        },

        SET_ASSET_TYPE(state, asset_type) {
            state.assetType = asset_type;
        },

        SET_ASSET_TYPE_DETAIL(state, asset_type) {
            state.typeDetail = asset_type;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

        USER_ASSIGN_LOADING (state, loading) {
            state.assignLoading = loading;
        },

        USER_ASSIGN_ERROR (state, hasError) {
            state.assignError = hasError;
        },

        ASSET_LOADING (state, loading) {
            state.assetLoading = loading;
        },

        ASSET_ERROR (state, hasError) {
            state.assetError = hasError;
        },

        ASSET_QR_LOADING (state, loading) {
            state.assetQRLoading = loading;
        },

        ASSET_QR_ERROR (state, hasError) {
            state.assetQRError = hasError;
        },

        ASSET_UNMARKED_LOADING (state, loading) {
            state.assetUnmarkedLoading = loading;
        },

        ASSET_UNMARKED_ERROR (state, hasError) {
            state.assetUnmarkedError = hasError;
        },

        ASSET_TYPE_LOADING (state, loading) {
            state.assetTypeLoading = loading;
        },

        ASSET_TYPE_ERROR (state, hasError) {
            state.assetTypeError = hasError;
        },

        ATTACHMENT_LOADING (state, loading) {
            state.attachmentLoading = loading;
        },

        ATTACHMENT_ERROR (state, hasError) {
            state.attachmentError = hasError;
        }
    },

    actions: {
        // User Assign to Asset
        async assignUsertoAsset ({commit, dispatch}, payload) {
            commit('USER_ASSIGN_LOADING', true);
            commit('USER_ASSIGN_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try {
                let response = await axios.post(V1API.assign_user_to_asset, { 
                    asset_id: payload.asset_id,
                    user_id: payload.user_id 
                }, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchAsset')
                return response

            } catch (e) {
                commit('USER_ASSIGN_ERROR', true);
            } finally {
                commit('USER_ASSIGN_LOADING', false);
            }
        },

        async deleteAssignedUser({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.delete_asset_assigned_user + payload.allocation_id + '/' + payload.volunteer_id, config).then(result=>{
                let data = result.data
                return data
            })
            
            if(payload.from_detail) {
                dispatch ('fetchAssetDetails', payload.asset_id)
            } else {
                dispatch ('fetchAsset')
            }
            return response
        },

        // Asset Feature
        async addFeature ({commit, dispatch}, payload) {
            commit('ASSET_TYPE_LOADING', true);
            commit('ASSET_TYPE_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try {
                let response = await axios.post(V1API.create_asset_type_feature, { 
                    type_id: payload.type_id,
                    feature: payload.feature 
                }, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchAssetTypeDetail', payload.type_id)
                return response

            } catch (e) {
                commit('ASSET_TYPE_ERROR', true);
            } finally {
                commit('ASSET_TYPE_LOADING', false);
            }
        },

        async removeFeature({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.asset_type_feature_delete + payload.delete_id, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchAssetTypeDetail', payload.type_id)
            return response
        },

        // Asset Type
        async addType ({commit, dispatch}, payload) {
            commit('ASSET_TYPE_LOADING', true);
            commit('ASSET_TYPE_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try {
                let response = await axios.post(V1API.create_asset_type, payload.asset, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchType')
                return response

            } catch (e) {
                commit('ASSET_TYPE_ERROR', true);
            } finally {
                commit('ASSET_TYPE_LOADING', false);
            }
        },

        async fetchType ({ commit }) {
            commit('ASSET_TYPE_LOADING', true);
            commit('ASSET_TYPE_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.asset_type_list, config);
                let response = result.data
                commit('SET_ASSET_TYPE', response.data);

            } catch(error) {
                commit('ASSET_TYPE_ERROR', true);
            } finally {
                commit('ASSET_TYPE_LOADING', false);
            }
        },

        async fetchAssetTypeDetail ({ commit }, payload) {
            commit('ASSET_TYPE_LOADING', true);
            commit('ASSET_TYPE_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.asset_type_details + payload, config);
                let response = result.data
                commit('SET_ASSET_TYPE_DETAIL', response.data);

            } catch(error) {
                commit('ASSET_TYPE_ERROR', true);
            } finally {
                commit('ASSET_TYPE_LOADING', false);
            }
        },

        async updateType ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let response = await axios.patch(V1API.update_asset_type + payload.id, payload.asset, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchType')
                return response

            } catch (e) {
                commit('ASSET_TYPE_ERROR', true);
            } finally {
                commit('ASSET_TYPE_LOADING', false);
            }
        },
        
        async deleteType({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.asset_type_delete + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchType')
            return response
        },

        // Asset
        async addAsset ({commit, dispatch}, payload) {
            commit('ASSET_LOADING', true);
            commit('ASSET_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
                "Content-Type": "multipart/form-data"
            };

            try {
                payload.specification=JSON.stringify(payload.specification)
                let data= new FormData()
                let payloadData = buildFormData(data, payload);

                let response = await axios.post(V1API.create_asset, payloadData, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchAsset')
                return response

            } catch (e) {
                commit('ASSET_ERROR', true);
            } finally {
                commit('ASSET_LOADING', false);
            }
        },

        async fetchAsset ({ commit }) {
            commit('ASSET_LOADING', true);
            commit('ASSET_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try {
                let result = await axios.get(V1API.asset_list, config);
                let response = result.data
                commit('SET_ASSET', response.data);

            } catch(error) {
                commit('ASSET_ERROR', true);
            } finally {
                commit('ASSET_LOADING', false);
            }
        },

        async fetchAssetDetails ({ commit }, payload) {
            commit('ASSET_LOADING', true);
            commit('ASSET_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.asset_detail + payload, config);
                let response = result.data
                commit('SET_ASSET_CODE', response.code);
                commit('SET_ASSET_DETAIL', response.data);

            } catch(error) {
                commit('ASSET_ERROR', true);
            } finally {
                commit('ASSET_LOADING', false);
            }
        },

        async updateAsset ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                payload.payload.specification=JSON.stringify(payload.payload.specification)
                let response = await axios.patch(V1API.update_asset + payload.id, payload.payload, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchAsset')
                return response

            } catch (e) {
                commit('ASSET_ERROR', true);
            } finally {
                commit('ASSET_LOADING', false);
            }
        },
        
        async deleteAsset({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.asset_delete + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchAsset')
            return response
        },


        // Asset Attachment
        async addAssetAttachment({commit, dispatch}, payload) {
            commit('ATTACHMENT_LOADING', true);
            commit('ATTACHMENT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
                "Content-Type": "multipart/form-data"
            };

            try {
                let data = new FormData()
                let payloadData = buildFormData(data, payload.attachment);

                let response = await axios.post(V1API.asset_add_attachment, payloadData, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchAssetDetails', payload.asset_id)
                return response

            } catch (e) {
                commit('ATTACHMENT_ERROR', true);
            } finally {
                commit('ATTACHMENT_LOADING', false);
            }
        },

        async deleteAttachmentFromAsset ({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.asset_delete_attachment + payload.id, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchAssetDetails', payload.asset_id)
            
            return response
        },

        // Asset QR
        async bulkAssetQRCreate ({commit, dispatch}, payload) {
            commit('ASSET_LOADING', true);
            commit('ASSET_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let response = await axios.post(V1API.create_bulk_asset_qr, payload, config).then(result=>{
                    let data = result.data
                    return data
                });
 
                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchAssetQR')
                return response

            } catch (e) {
                commit('ASSET_ERROR', true);
            } finally {
                commit('ASSET_LOADING', false);
            }
        },

        async fetchAssetQR ({ commit }) {
            commit('ASSET_QR_LOADING', true);
            commit('ASSET_QR_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try {
                let result = await axios.get(V1API.bulk_asset_qr_list, config);
                let response = result.data
                commit('SET_QR_ASSET', response.data);

            } catch(error) {
                commit('ASSET_QR_ERROR', true);
            } finally {
                commit('ASSET_QR_LOADING', false);
            }
        },

        // Asset ID's
        async fetchUnmarkedAssetIDs ({ commit }) {
            commit('ASSET_UNMARKED_LOADING', true);
            commit('ASSET_UNMARKED_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try {
                let result = await axios.get(V1API.unmarked_asset_ids, config);
                let response = result.data
                commit('SET_UNMARKED_ASSET', response.data);

            } catch(error) {
                commit('ASSET_UNMARKED_ERROR', true);
            } finally {
                commit('ASSET_UNMARKED_LOADING', false);
            }
        }
    },

    getters: {}
}
